<template>
  <!-- 改版的footer -->
  <div class="footer_x">
    <div class="footer_content">
      <div class="footer_section">
        <p class="section_title">{{$t('footer.help')}}<!-- 帮助 --></p>
        <p><a :href="domain + 'about.php?op=question'">{{$t('footer.footer_use_of_question')}} <!-- 常见问题 --></a></p>
        <p><a :href="domain + 'sitemap.php'">{{$t('footer.footer_sitemap')}} <!--站点地图 --></a></p>
        <p><a :href="domain + 'about.php?op=contact'">{{$t('footer.footer_contact_us')}} <!-- 联系我们 --></a></p>
        <p><a :href="domain + 'about.php?op=policy'">{{$t('footer.privacy_policy')}} <!-- 隐私政策 --></a></p>
        <p><a :href="domain + 'about.php?op=clause'">{{$t('footer.use_of_terms')}}<!-- 服务条款 --></a></p>
        <p><a :href="domain + 'about.php?op=integral'">{{$t('footer.privacy_policy')}}<!-- 积分政策 --></a></p>
      </div>
      <div class="footer_section">
        <p class="section_title">{{$t('footer.footer_about_us')}} <!-- 关于我们 --></p>
        <p><a :href="domain + 'about.php'">{{$t('footer.about_baigolf')}} <!-- 关于BaiGolf --></a></p>
        <p><a :href="domain + 'news.php?act=news_list'">{{$t('footer.news_center')}}<!-- 新闻中心 --></a></p>
        <p><a :href="domain + 'about.php?op=reserve'">{{$t('footer.footer_reserve')}} <!-- 预订政策 --></a></p>
        <p><a :href="domain + 'BaigolfClub.php'">BaiGolf Club Card</a></p>
        <p><a :href="domain + 'about.php?op=man_system'">{{$t('footer.management_system')}}<!-- 球会管理系统 --></a></p>
      </div>
      <div class="footer_section phone_section">
        <img class="icon_phone" src="../../static/images/footer_header/phone.png" alt="">
        <div class="concat_phone">
          <p>400-809-1328（{{$t('footer.footer_internal_call')}}）<!-- 中国大陆 --></p>
          <p>+86-20-3846-8827（{{$t('footer.footer_abroad_call')}}） <!-- 海外 --> </p>
          <a href="https://weibo.com/u/6497015621?is_all=1">
            <img class="icon_weibo" src="../../static/images/footer_header/weibo.png" alt="">
          </a>
        </div>
      </div>
      <div class="footer_section qr_code_f">
        <div class="public_code">
          <img src="../../static/images/footer_header/public_number.png" alt="">
          <p class="qr_name_1">{{$t('footer.wechat_official_account')}}<!-- 关注微信公众号 --></p>
        </div>
        <div class="download_code">
          <img src="../../static/images/footer_header/download.png" alt="">
          <p class="qr_name_1">{{$t('footer.download_baiGolf_app')}}<!-- 扫码免费下载App --></p>
        </div>
      </div>
    </div>
    <p class="keep_on_record">
      <span>&copy; 2014-2019 baigolf.com,All Rights Reserved. </span>
      <a target="_blank" href="http://www.beian.miit.gov.cn/">粤ICP备17156604号</a>
    </p>
  </div>
</template>

<script>
    export default {
      name: "BgFoot",
      data () {
        return {
          domain: 'https://www.baigolf.com/'
        }
      }
    }
</script>

<style lang="scss" scoped>
  .bg-foot{
    background: #ededed url("https://www.baigolf.com/templates/images/footer/t.gif") no-repeat center top;
    padding: 40px 0 0;
    margin-top: 100px;
    .foot-item{
      width: 50%;
      .item-title{
        margin-bottom: 10px;
      }
      a{
        font-size: 13px;
        color:#666;
        img{
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    .foot-r{
      width: 40%;
      .foot-r-item{
        width: 50%;
      }
    }
    .right-line{
      position: relative;
      &:before{
        position: absolute;
        content: "";
        display: block;
        border-right: 1px solid #ccc;
        height: 150px;
        right: 0;
        top: 0px;
      }
    }
    .copy{
      background: #ddd;
      line-height: 40px;
      margin-top: 20px;
    }
  }

  /** 新版 footer **/
  .footer_x{
    background-color: #42464E;
    padding-top: 80px;
    .footer_content{
      width: 1180px;
      margin: 0 auto;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1515);
      .footer_section{
        display: inline-block;
        vertical-align: top;
        p{
          padding-bottom: 20px;
          a{
            font-size: 16px;
            color: #A7A7A7;
            line-height: 21px;
          }
        }
        .section_title{
          font-size: 18px;
          color: #fff;
          line-height: 24px;
        }
      }
       .footer_section:nth-child(1){
        width: 192px;
      }
      .footer_section:nth-child(2){
        width: 259px;
      }
      .footer_section:nth-child(3){
        width: 307px;
      }
    }
  }
  .phone_section{
    .icon_phone{
      width: 40px;
      height: 40px;
      margin-top: 11px;
      vertical-align: top;
    }
    .concat_phone{
      display: inline-block;
      padding-left: 11px;
      p{
        color: #fff;
      }
    }
  }
  .qr_code_f{
    &>div{
      width: 200px;
      text-align: center;
      display: inline-block;
      vertical-align: top;
    }
    p{
      color: #A7A7A7;
      font-size: 16px;
      line-height: 21px;
    }
    .qr_name_1{
      padding: 16px 0 0 0!important;
    }
    .qr_name_2{
      padding: 6px 0 0 0!important;
    }
  }

  .keep_on_record,.keep_on_record a{
    text-align: center;
    color: #A7A7A7;
    line-height: 60px;
  }

</style>



// WEBPACK FOOTER //
// src/components/BgFoot.vue